import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PageHeader } from "@excoleadershipui/pionweblib";
import { Link, useLocation } from "react-router-dom";
// material ui
import { Stack, Box, IconButton } from "@mui/material";

// icons
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
// components
import AddQuestionType from "./AddMappingAccounts";
import UpdateQuestionType from "./UpdateMappingAccounts";
import Layout from "../../../../layout/Layout";
import { MuiDataGrid, GridCellExpand, Notifier, ErrorNotifier, MuiTooltip } from "../../../../components";
import ConfirmDialog from "../../../../components/common/ConfirmDialog";
// redux
import {
  getQuestionType,
  deleteQuestionType,


} from "../../../../features/config/questionTypeSlice";

import {
  getAccountMappingChr, rowSelect, deleteAccountMappingChr, resetMessage,
  resetErrMessage,
} from "../../../../features/auth/authChrSlice";
// ----------------------------------------------------------------------------------

const QuestionType = () => {
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const location = useLocation()
  const dispatch = useDispatch();

  const { questionTypeData, message, errMessage } =
    useSelector((state) => ({ ...state.questionType }));

  const { selectedData, accountMappingdata, selectedAccountData } = useSelector((state) => ({ ...state.authChr }))

  function renderCellExpand(params) {
    return (
      <GridCellExpand
        value={params.value || ""}
        width={params.colDef.computedWidth}
      />
    );
  }

  const data = {
    rows: accountMappingdata?.length > 0 ? accountMappingdata : [],
    columns: [
      { field: "accountName", headerName: "Account Name", width: 250 },
      {
        field: "delete",
        // headerName: 'Clone',
        type: "actions",


        width: 70,
        renderCell: (params) => {
          return (
            <MuiTooltip title="Delete" placement="right">


              <IconButton
                sx={{ p: 0 }}
                onClick={() => {
                  showDelete(params?.row)

                  // dispatch(rowSelect(params?.row))
                }}
              >
                <DeleteIcon style={{ color: "#FF0000" }} />
              </IconButton>


            </MuiTooltip>
          );
        },
      },

    ],
  };

  const showAddPage = () => {
    setShowAdd(!showAdd);
  };

  const showEditPage = () => {
    setShowEdit(true);
  };

  const showDelete = (data) =>
    setConfirmDialog({
      isOpen: true,
      title: "Are you sure to delete this record?",
      subTitle: "You can't undo this operation",
      onConfirm: () => handleDelete(data),
    })

  useEffect(() => {
    dispatch(getAccountMappingChr(selectedData?.
      assessmentUserChr?.id
    ));
  }, []);

  const handleSetConfirmDialog = (obj) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: obj.isOpen,
    });
  };

  console.log(selectedAccountData)

  const handleDelete = (dataId) => {

    let data = {
      id: dataId?.assessmentUserChrAccount?.id,
    };
    dispatch(deleteAccountMappingChr(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          dispatch(getAccountMappingChr(selectedData?.
            assessmentUserChr?.id
          ));
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 3000);
      }
    });
  };

  return (
    <>

      <>
        <Stack flexDirection="row" justifyContent="space-between">
          {/* <Box sx={{ width: "100%" }}>
            <PageHeader variant="pageSecHeader">Account Mapping</PageHeader>
          </Box> */}

        </Stack>
        <MuiDataGrid
          height={300}
          // setShowAdd={ showAddPage}
          // setShowEdit={ showEditPage}
          // setShowDelete={ showDelete
          // }
          // setShowAdd={ showAddPage}
          // setShowEdit={ showEditPage}
          // setShowDelete={ showDelete
          // }
          // toolbarColumn={true}
          // toolbarFilter = {true}
          // toolbarDensity={true}
          // toolbarExport={true}
          data={data}
        // select={(data) => dispatch(rowSelect(data))}
        />
      </>

      {showAdd && (
        <AddQuestionType
          showAdd={showAdd}
          close={() => setShowAdd(false)}
        />
      )}
      {showEdit && (
        <UpdateQuestionType
          showEdit={showEdit}
          close={() => setShowEdit(false)}
        />
      )}
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={(obj) => handleSetConfirmDialog(obj)}
      />
      {message && <Notifier message={message} />}
      {errMessage && <ErrorNotifier message={errMessage} />}
    </>
  );
};

export default QuestionType;
